export const REFRESH_TOKEN_EXPIRED = "refresh-token-expired";

export interface SessionExpiredPayload {
  loginUrl: string;
}

type Listener = (payload: SessionExpiredPayload) => void;

const listeners = new Set<Listener>();
let alreadyTriggered = false;

export const triggerSessionExpired = (
  payload: SessionExpiredPayload,
): boolean => {
  if (listeners.size === 0) return false;
  if (alreadyTriggered) return true;
  alreadyTriggered = true;
  listeners.forEach((listener) => listener(payload));
  return true;
};

// True once a session-expired sequence has actually been shown to the user.
// Lets later, unrelated redirect calls in the same failure chain (e.g. a
// retry that runs after the refresh call already triggered the modal) avoid
// racing it with a silent hard redirect.
export const isSessionExpiredTriggered = (): boolean => alreadyTriggered;

export const subscribeSessionExpired = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
